//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    productName: { type: String, required: true },
    subtitle: { type: String, required: true },
    size: { type: String, validator: val => ['regular', 'small'].includes(val), default: 'regular' },
    subtitleAboveTitle: { type: Boolean, default: true },
    renderEmptySubtitle: { type: Boolean, default: true }
  },
  computed: {
    titleSize () {
      return {
        regular: 'h1',
        small: 'h4'
      }[this.size]
    },
    subtitleSize () {
      return {
        regular: 'h5',
        small: 'h5'
      }[this.size]
    },
    tag () {
      return {
        regular: 'h2',
        small: 'div'
      }[this.size]
    }
  }
}
